import React, { useState, useEffect } from "react";
import { collection, getDocs } from "firebase/firestore";
import { firestore as db } from "../FirebaseConfig";
import ProductCard from "./listOfProducts/ProductCard";
import { IoIosArrowDown } from "react-icons/io";
import { useLocation, useSearchParams } from "react-router-dom";
import { Swiper, SwiperSlide } from "swiper/react";
import { FreeMode } from "swiper/modules";
import Carousel from "./carousel/Carousel";
import Lottie from "lottie-react";

const Shop = () => {
  const [categories, setCategories] = useState([]);
  const [products, setProducts] = useState([]);
  const [filteredProducts, setFilteredProducts] = useState([]);
  const [selectedCategories, setSelectedCategories] = useState([]);
  const [sortOption, setSortOption] = useState("Featured");
  const [searchQuery, setSearchQuery] = useState("");
  const location = useLocation();
  const [trendingData, setTrendingData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [animationData, setAnimationData] = useState(null);
  const [searchParams] = useSearchParams();

  useEffect(() => {
    
    window.scrollTo(0, 0);
    const query = searchParams.get("search");
if (query) {
  setSearchQuery(query);
}

  }, []);


  useEffect(() => {
    const fetchTrendingItems = async () => {
      try {
        const querySnapshot = await getDocs(collection(db, "trending"));
        const fetchedData = querySnapshot.docs.map((doc) => ({
          id: doc.id,
          image: doc.data().image,
          title: doc.data().tag,
        }));
        setTrendingData(fetchedData);
      } catch (error) {
        console.error("Error fetching trending items:", error);
      }
    };

    fetchTrendingItems();
  }, []);


  

  useEffect(() => {
    const fetchCategories = async () => {
      const categorySnapshot = await getDocs(collection(db, "categories"));
      const categoryList = categorySnapshot.docs.map((doc) => ({
        id: doc.id,
        ...doc.data(),
      }));
      setCategories(categoryList);
   
      const categorySlug = searchParams.get("category");

if (categorySlug) {
  const slugs = categorySlug.split("--");
  const matchedCategories = categoryList.filter((cat) => slugs.includes(cat.slug));
  const matchedCategoryIds = matchedCategories.map((cat) => cat.id);

  setSelectedCategories(matchedCategoryIds);
  setFilteredProducts(products.filter((product) =>
    matchedCategoryIds.includes(product.categoryId)
  ));
}


  
    };

    const fetchProducts = async () => {
      const productSnapshot = await getDocs(collection(db, "products"));
      const productList = productSnapshot.docs.map((doc) => ({
        id: doc.id,
        ...doc.data(),
      }));
      setProducts(productList.filter(product => product.main === true));
      setFilteredProducts(productList);
      setLoading(false);
    };



    fetchCategories();
    fetchProducts();
  }, []);

  useEffect(() => {
    let updatedProducts = products;

    if (selectedCategories.length > 0) {
      updatedProducts = products.filter((product) =>
        selectedCategories.includes(product.categoryId)
      );
    }

    if (searchQuery) {
      updatedProducts = updatedProducts.filter((product) =>
        product.name.toLowerCase().includes(searchQuery.toLowerCase())
      );
    }

    switch (sortOption) {
      case "Price: High to Low":
        updatedProducts.sort((a, b) => (a.prices.productPrice - a.prices.productDiscount) - (b.prices.productPrice - b.prices.productDiscount));
        break;
      case "Price: Low to High":
        updatedProducts.sort((a, b) => (b.prices.productPrice - b.prices.productDiscount) - (a.prices.productPrice - a.prices.productDiscount));
        break;
      case "Avg. Rating":
        updatedProducts.sort((a, b) => b.rating - a.rating);
        break;
      default:
        break;
    }

  

    setFilteredProducts(updatedProducts);

    const groupedByCategory = {};
    updatedProducts.forEach((product) => {
      if (!groupedByCategory[product.categoryId]) {
        groupedByCategory[product.categoryId] = [];
      }
      groupedByCategory[product.categoryId].push(product);
    });
    

    const orderedCategories = categories
    .filter((cat) => groupedByCategory[cat.id])
    .sort((a, b) => a.index - b.index); // sort by category index

  // Final list: products grouped by category index and sorted in-stock first
  const finalProductList = [];

  orderedCategories.forEach((category) => {
    const group = groupedByCategory[category.id];

    const inStock = group.filter((prod) => prod.inStock);
    const outOfStock = group.filter((prod) => !prod.inStock);

    finalProductList.push(...inStock, ...outOfStock);
  });

  setFilteredProducts(finalProductList);

  }, [selectedCategories, sortOption, products, searchQuery]);

  const handleCategoryChange = (category) => {
    if (selectedCategories.includes(category)) {
      setSelectedCategories(selectedCategories.filter((cat) => cat !== category));
    } else {
      setSelectedCategories([...selectedCategories, category]);
    }
  };

  const handleMCategoryChange = (categoryId) => {
    if (categoryId === "all") {
      setSelectedCategories([]);
      setFilteredProducts(products);
    } else {
      setSelectedCategories([categoryId]);
      setFilteredProducts(products.filter((product) => product.categoryId === categoryId));
    }
  };

  useEffect(() => {
    fetch("/assets/General/loadingBee.json")
      .then((response) => response.json())
      .then((data) => setAnimationData(data))
      .catch((error) => console.error("Error loading animation:", error));
  }, []);

  if (loading) {
    return (
      <div className="h-screen flex justify-center items-center">
        <div className="w-1/2 md:w-1/4">
          <Lottie animationData={animationData} loop autoPlay />
        </div>
      </div>
    );
  }

  return (
    <div className="mt-27 container mx-auto px-4 py-10">
      {trendingData.length > 0 ? <Carousel data={trendingData} /> : <p>Loading trending items...</p>}

      <div className="md:flex justify-end hidden w-full px-4 py-2 mb-2">

      <div className=" w-[400px] ">
          <input
            type="text"
            placeholder="Search for products..."
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
            className="w-full px-2 py-2 border border-gray-300 rounded-lg focus:outline-none focus:border-orange-500"
          />
        </div>
        </div>

      <div className="flex flex-col lg:flex-row gap-8">
        {/* Mobile Search Bar */}
        <div className="lg:hidden w-full mb-2">
          <input
            type="text"
            placeholder="Search for products..."
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
            className="w-full px-2 py-2 border border-gray-300 rounded-lg focus:outline-none focus:border-orange-500"
          />
        </div>

        {/* Categories Sidebar for Mobile */}
        <div className="lg:hidden w-full bg-white py-4 shadow-md rounded-lg">
          <Swiper
            slidesPerView={"auto"}
            spaceBetween={0}
            freeMode={true}
            modules={[FreeMode]}
          >
            <SwiperSlide
              key={"All"}
              className="flex mx-1 flex-col items-center justify-center cursor-pointer text-center min-w-[90px] max-w-[110px] space-y-2"
              onClick={() => handleMCategoryChange("all")}
            >
              <div className="w-15 h-15 bg-gray-100 rounded-full flex items-center justify-center shadow-sm">
                <img
                  src={"/assets/shop_page/all_honey.png"}
                  alt={"All"}
                  className="w-15 h-15"
                />
              </div>
              <p className="text-sm font-medium text-center max-w-[65px]">{"All"}</p>
            </SwiperSlide>
            {categories.filter(category => category.availability === true).sort((a, b) => a.index - b.index).map((category) => (
              <SwiperSlide
                key={category.id}
                className="flex mx-1 flex-col items-center justify-center cursor-pointer text-center min-w-[90px] max-w-[110px] space-y-2"
                onClick={() => handleMCategoryChange(category.id)}
              >
                <div>
                  <div className="w-15 h-15 bg-gray-100 rounded-full flex items-center justify-center shadow-sm">
                    <img
                      src={category.icon}
                      alt={category.name}
                      className="w-15 h-15"
                    />
                  </div>
                  <p className="text-sm mt-2 font-medium text-center leading-tight max-w-[60px]">
                    {category.name.replace("Honey", "")}
                  </p>
                </div>
              </SwiperSlide>
            ))}
          </Swiper>
        </div>

        {/* Categories Sidebar for Desktop */}
        <div className="hidden lg:block w-full lg:w-1/4 bg-white shadow-md rounded-lg p-5">
          <h3 className="text-xl font-bold mb-4">Categories</h3>
          {categories.filter(category => category.availability === true).sort((a, b) => a.index - b.index).map((category) => (
            <div key={category.id} className="flex items-center space-x-2 mb-2">
              <input
                type="checkbox"
                id={category.slug}
                checked={selectedCategories.includes(category.id)}
                onChange={() => handleCategoryChange(category.id)}
                className="accent-orange-500 cursor-pointer"
              />
              <label htmlFor={category.slug} className="cursor-pointer">
                {category.name}
              </label>
            </div>
          ))}
        </div>

        {/* Products Section */}
        <div className="w-full lg:w-3/4">
          <div className="flex flex-col lg:flex-row justify-between items-center mb-6">
            <p className="text-gray-600">{filteredProducts.length} Products found</p>
            <select
              className="border border-gray-300 rounded px-4 py-2"
              value={sortOption}
              onChange={(e) => setSortOption(e.target.value)}
            >
              <option value="Featured">Sort by: Featured</option>
              <option value="Price: Low to High">Price: Low to High</option>
              <option value="Price: High to Low">Price: High to Low</option>
              <option value="Avg. Rating">Avg. Rating</option>
            </select>
          </div>

          {/* Product Grid */}
          <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-6">
            {filteredProducts.length > 0 ? (
              filteredProducts.map((product) => <ProductCard key={product.id} data={product} />)
            ) : (
              <p className="col-span-full text-center text-gray-500">No products available</p>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Shop;